import { router } from '@inertiajs/react';
import AddIcon from '@mui/icons-material/Add';
import ClearIcon from '@mui/icons-material/Clear';
import NotificationsRoundedIcon from '@mui/icons-material/NotificationsRounded';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import * as React from 'react';
import MenuButton from '../../components/MenuButton';
import NavbarBreadcrumbs from '../../components/NavbarBreadcrumbs';
import Search from '../../components/Search';
import ColorModeIconDropdown from '../../theme/ColorModeIconDropdown';

export default function DriversHeader({
  showAddButton = false,
  searchTerm,
  onSearchChange,
  searchInputRef,
  placeholder = "Pesquisar...",
  totalResults,
  totalDrivers,
  hasSearch,
  onClearSearch
}) {
  const handleAddClick = () => {
    router.get('/drivers/new');
  };

  // Only show search if search props are provided
  const showSearch = onSearchChange && searchInputRef;

  return (
    <Stack
      direction="row"
      sx={{
        display: { xs: 'none', md: 'flex' },
        width: '100%',
        alignItems: { xs: 'flex-start', md: 'center' },
        justifyContent: 'space-between',
        maxWidth: { sm: '100%', md: '1700px' },
        pt: 1.5,
      }}
      spacing={2}
    >
      <Stack direction="row" spacing={1} alignItems="center">
        <NavbarBreadcrumbs />

        {/* Contadores de resultados */}
        {hasSearch && (
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{
              fontSize: '0.75rem',
              backgroundColor: 'action.hover',
              px: 1.5,
              py: 0.5,
              borderRadius: 1,
              whiteSpace: 'nowrap'
            }}
          >
            {totalResults} de {totalDrivers} motoristas
          </Typography>
        )}
      </Stack>

      <Stack direction="row" sx={{ gap: 1, alignItems: 'center' }}>
        {/* Campo de pesquisa - apenas se props de pesquisa estiverem presentes */}
        {showSearch && (
          <Search
            value={searchTerm}
            onChange={onSearchChange}
            inputRef={searchInputRef}
            placeholder={placeholder}
          />
        )}

        {/* Botão para limpar busca */}
        {hasSearch && (
          <Tooltip title="Limpar busca">
            <IconButton
              onClick={onClearSearch}
              size="small"
              color="primary"
              sx={{
                '&:hover': {
                  backgroundColor: 'action.hover'
                }
              }}
            >
              <ClearIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        )}

        {/* Botão Adicionar Motorista */}
        {showAddButton && (
          <Button
            variant="outlined"
            startIcon={<AddIcon />}
            onClick={handleAddClick}
            sx={{
              minWidth: 'fit-content',
              height: '36px'
            }}
          >
            Adicionar Motorista
          </Button>
        )}

        <MenuButton showBadge aria-label="Notificações">
          <NotificationsRoundedIcon />
        </MenuButton>

        <ColorModeIconDropdown />
      </Stack>
    </Stack>
  );
} 